import {
    ApiHandler,
    HasOnSuccess,
    HasOnError,
    HasOnComplete,
    createHandlerChainRunner,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";

import {
    submitProductRequestForm,
    ProductRequestForm,
    ProductRequestResponse,
} from "@tCentro/Services/NISPLPNoSearchOptiFormService";

type HandlerType = ApiHandler<
    ProductRequestForm & HasOnSuccess<ProductRequestResponse> & HasOnError & HasOnComplete,
    ProductRequestResponse
>;

export const PopulateApiParameter: HandlerType = props => {
    const { firstName, lastName, email, brandName, productNumber, addionalProductInfo } = props.parameter;

    props.apiParameter = {
        firstName,
        lastName,
        email,
        brandName,
        productNumber,
        addionalProductInfo,
    };
};

export const CallApi: HandlerType = async props => {
    try {
        props.apiResult = await submitProductRequestForm(props.apiParameter);
    } catch (error: any) {
        props.apiResult = {
            message: error.errorJson?.message || error.errorMessage || "Unexpected server error",
            status: "error",
        };
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    const msg = props.apiResult?.message?.toLowerCase() || "";

    if (msg.includes("error") || msg.includes("fail") || msg.includes("invalid")) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.();
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    const msg = props.apiResult?.message?.toLowerCase() || "";

    if (msg.includes("success") || props.apiResult?.status === "success") {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const chain = [PopulateApiParameter, CallApi, ExecuteOnErrorCallback, ExecuteOnSuccessCallback];

const submitProductRequestFormHandler = createHandlerChainRunner(chain, "submitProductRequestFormHandler");

export default submitProductRequestFormHandler;
